/* eslint-disable @typescript-eslint/no-explicit-any */
import { PureComponent } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  // CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const data = [
  {
    name: "Initial revenue",
    revenue: 524,
    cost: 288,
    grossProfit: 236,
  },
  {
    name: "Projected revenue",
    revenue: 546,
    cost: 300,
    grossProfit: 246,
  },
  {
    name: "Earned revenue",
    revenue: 310,
    cost: 186,
    grossProfit: 124,
  },
];

const CustomTooltip = ({ active, payload, label }: any) => {
  if (active && payload && payload.length) {
    const data = payload[0].payload;
    const percent = ((data.grossProfit / data.revenue) * 100).toFixed(0);

    return (
      <div
        style={{
          backgroundColor: "#1e1e1e",
          padding: 12,
          borderRadius: 10,
          color: "#fff",
          minWidth: 250,
        }}
      >
        <div style={{ fontWeight: "600", marginBottom: 8 }}>{label}</div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <span>Revenue</span>
          <b>${data.revenue}K</b>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: 6,
          }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <span
              style={{
                backgroundColor: "#6454F4",
                borderRadius: "50%",
                width: 8,
                height: 8,
                marginRight: 6,
              }}
            ></span>
            <span>Cost</span>
          </div>
          <b>${data.cost}K</b>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: 4,
          }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <span
              style={{
                backgroundColor: "#C5C8FF",
                borderRadius: "50%",
                width: 8,
                height: 8,
                marginRight: 6,
              }}
            ></span>
            <span>Gross profit</span>
          </div>
          <b>
            {percent}% (${data.grossProfit}K)
          </b>
        </div>
      </div>
    );
  }

  return null;
};

const RoundedBar = (props: any) => {
  const { x, y, width, height, fill } = props;

  const radius = 10;

  return (
    <path
      d={`
        M${x},${y + height}
        V${y + radius}
        Q${x},${y} ${x + radius},${y}
        H${x + width - radius}
        Q${x + width},${y} ${x + width},${y + radius}
        V${y + height}
        Z
      `}
      fill={fill}
    />
  );
};
const RoundedBar2 = (props: any) => {
  const { x, y, width, height, fill } = props;

  const radius = 10;

  return (
    <path
      d={`
        M${x},${y}
        V${y + height - radius}
        Q${x},${y + height} ${x + radius},${y + height}
        H${x + width - radius}
        Q${x + width},${y + height} ${x + width},${y + height - radius}
        V${y}
        Z
      `}
      fill={fill}
    />
  );
};

export default class Example extends PureComponent {
  render() {
    return (
      <div style={{ width: "100%", height: 500 }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            width={500}
            height={300}
            data={data}
            margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
          >
            {/* <CartesianGrid strokeDasharray="5 2" /> */}
            <XAxis dataKey="name" axisLine={false} tickLine={false} />
            <YAxis
              tickFormatter={(value) => `$${value}K`}
              axisLine={false}
              tickLine={false}
              ticks={[0, 100, 200, 300, 400, 500, 600]}
              style={{
                fontSize: 12,
                color: "#151718",
                fontWeight: 400,
                textAlign: "left",
              }}
            />
            <Tooltip
              content={<CustomTooltip />}
              cursor={{ fill: "rgba(100, 100, 100, 0.05)" }}
            />
            <Legend verticalAlign="top" />
            {/* Stack: Cost (lighter), Gross Profit (darker) */}
            <Bar
              dataKey="cost"
              stackId="a"
              fill="#6454F4"
              name="Cost"
              shape={<RoundedBar2 />}
            />
            <Bar
              dataKey="grossProfit"
              stackId="a"
              fill="#C5C8FF"
              name="Gross profit"
              shape={<RoundedBar />}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    );
  }
}
